import { ThemeUnion } from '@almbrand/systemicons/dist/cjs/types/icon';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { removeItem, selectBasketItems } from 'store/slices/basketSlice';
import { Basket, BasketItem } from '../Basket';

export type QuickBasketProps = {
	themeName: ThemeUnion;
};

export const QuickBasket: React.FC<QuickBasketProps> = ({ themeName }) => {
	const basketItems = useAppSelector(selectBasketItems);
	const dispatch = useAppDispatch();

	const mappedBasketItems: BasketItem[] = basketItems.map((item) => ({
		id: item.basketItemId,
		price: item.price ? Number(item.price) : undefined,
		themeName: themeName,
		deleteBtnLabel: 'Remove',
		editBtnLabel: 'Edit',
		pendingCalculationText: 'Pending calculation',
		detailsBtnLabel: 'Details',
		title: item.name,
		subtitle: item.id,
	}));

	return (
		<Basket
			items={mappedBasketItems}
			addMoreAriaLabel=''
			deleteConfirmationConfirmBtnLabel='Remove'
			deleteConfirmationDescription='Are you sure you want to remove this product?'
			deleteConfirmationTitle='Remove product?'
			existingCustomerTitle='Existing customer'
			summary={{ discountLines: [], totalAmount: 0 }}
			onBack={() => console.log('Back')}
			onCheckout={() => console.log('Checkout')}
			summaryCardTotal='Total'
			summaryCardLegalText='Summary Card Legal Text'
			title=''
			onDelete={(id) => dispatch(removeItem(id))}
		/>
	);
};
